import { AddOnAvailability, AddOnType, BallotSection, ChallengeActivity, CreateBallotRequest, CreateBallotResponse, CreateChallengeRewardRequest, CreateElectionRequest, CreateElectionResponse, FeatureTierLevel, FeatureTierMonthlyPriceMap, FeatureType, FormFieldType, GetAddOnResponse, GetBallotResponse, GooglePlaceTypeSearch, LogicFieldType, PointEmailCaptureCustomization, PopUpCustomization, PopUpTypeOld, RegistrationSettings, RewardCriteria, ScavengerHuntSettings, VisibilityField } from '../types';

import { getCookie } from './device';
import { palette } from '../style/variables';

function getPageResponseHeaders(...names: string[]) {
    const req = new XMLHttpRequest();
    req.open('HEAD', document.location.toString(), false);
    req.send(null);

    const result = {} as any;
    names.forEach((n) => (result[n] = req.getResponseHeader(n)));

    return result;
}


export const HEADERS = getPageResponseHeaders(
    'X-Google-Key',
    'X-Icons8-Key',
    'X-Telemetry-Endpoint',
    'X-Uri',
    'X-Embedly-Key',
    'X-Weglot-Key-One',
    'X-Weglot-Key-Two',
);

export const ImageSizingGuide = 'https://scribehow.com/viewer/Proxi_Image_Upload_Guide__MA9pCjxKQOuc1YbL6BSJHw';

/** The all-zero id a point carries when it has no category. */
export const ZERO_OBJECT_ID = '000000000000000000000000';


export const MONETIZATION_ENABLED = true;

export const DUMMY_DATE = '1970-01-01';

// One-shot notice carried across a registration-page reload (e.g. after a login that didn't match a
// registration, or a registration that was removed).
export const REGISTRATION_NOTICE_KEY = 'proxi_registration_notice';
export const NO_REGISTRATION_FOUND_NOTICE = "We couldn't find a registration under that email. Register under a new one below, or try a different email.";

// One-shot toast carried across a registration-page reload, for errors we also log to the console
// (so a customer can tell us what they saw).
export const REGISTRATION_TOAST_KEY = 'proxi_registration_toast';
export const LOGIN_LOOKUP_ERROR_TOAST = "You're signed in, but we had trouble loading your page. Please try again — and if it keeps happening, let us know what you see.";

export const DEFAULT_TAG_COLORS =
['#f44336',
'#e81e63',
'#9c27b0',
'#673ab7',
'#3f51b5',
'#2196f3',
'#03a9f4',
'#00bcd4',
'#009688',
'#4caf50',
'#8bc34a',
'#cddc39',
'#ffeb3b',
'#ffc107',
'#ff9800',
'#ff5722',
'#795548',
'#9e9e9e',
'#607d8b'];

export const DEFAULT_CATEGORY_COLORS = [
    '#ff59f3',
    '#be0e14',
    '#ffca3a',
    '#be8f0e',
    '#8ac926',
    '#628824',
    '#4bb738',
    '#337d26',
    '#1982c4',
    '#1b5b83',
    '#6a4c93',
    '#4d3a67',
    '#8c4d94',
    '#65376d',
    '#ffffff',
    '#222222',
];

export let ICONS8_KEY = getCookie('ICONS8_KEY');

if (ICONS8_KEY === undefined) {
    ICONS8_KEY = HEADERS['X-Icons8-Key'];
}

export const TELEMETRY_ENDPOINT = getCookie('TELEMETRY_ENDPOINT') ??  HEADERS['X-Telemetry-Endpoint'] as string;

export const URI = `${window.location.protocol}//${window.location.host}`;

export const HOST = `//${window.location.host}`;

export const ZOOM_TYPES = [
    'World',
    'Hemisphere',
    'Continent',
    'Region',
    'Province',
    'Large City',
    'Small City',
    'Neighborhood',
    'Block',
    'Street',
    'Grain of Sand',
];

export const MAP_STYLES_COLLECTION = [
    {
        title: 'standard',
        label: 'Standard',
        img: '/images/maps/standard.png',
        mapId: 'd8ce8f89e8ceebd2',
    },
    {
        title: 'satellite',
        label: 'Satellite',
        img: '/images/maps/satellite.png',
        mapId: 'd8ce8f89e8ceebd2'
    },
    {
        title: 'hybrid',
        label: 'Satellite + Roads',
        img: '/images/maps/hybrid.png',
        mapId: 'd8ce8f89e8ceebd2'
    },
    {
        title: 'blue',
        label: 'Blue',
        img: '/images/maps/blue.png',
        mapId: '493dd6f8172fdad'
    },
    {
        title: 'paper',
        label: 'Paper',
        img: '/images/maps/paper.png',
        mapId: '7cab6c1b23ad8b93'
    },
    {
        title: 'muted',
        label: 'Muted',
        img: '/images/maps/muted.png',
        mapId: 'f71d5ee61f112aa4'
    },
    {
        title: 'bright',
        label: 'Bright',
        img: '/images/maps/bright.png',
        mapId: '6b4f3ff71a80e590'
    },
    {
        title: 'sketch',
        label: 'Sketch',
        img: '/images/maps/sketch.png',
        mapId: '315463482998eb2b'
    },
    {
        title: 'explorer',
        label: 'Explorer',
        img: '/images/maps/explorer.png',
        mapId: '6872af6b9ee16bf8'
    },
    {
        title: 'love',
        label: 'Love',
        img: '/images/maps/love.png',
        mapId:'5968a3f1f83fd347'
    },
    {
        title: 'apple',
        label: 'Apple',
        img: '/images/maps/apple.png',
        mapId:'d126585581364865'
    },
        {
        title: 'fireworks',
        label: 'Fireworks',
        img: '/images/maps/fireworks.png',
        mapId:'2f90218f5eded3a1'
    },
        {
        title: 'night',
        label: 'Night',
        img: '/images/maps/night.png',
        mapId:'c2acaa6867aa8965'
    },
    {
        title: 'spooky',
        label: 'Spooky',
        img: '/images/maps/spooky.png',
        mapId:'8f7bf8d718fc52f6'
    },
    {
        title: 'holiday',
        label: 'Holiday',
        img: '/images/maps/holiday.png',
        mapId:'334db955f76a1f7f'
    },
    {
        title: 'clear',
        label: 'Clear (no image)',
        img: '/images/maps/clear.png',
        mapId:'d50fba41eb3b8114f10cd56f'
    },
    {
        title: 'custom - woods capital',
        organization_id: '67928e8f8bd43758690626a3',
        private: true,
        label: 'Woods',
        img: '/images/maps/custom.png',
        mapId:'7f7684953d003e85'
    },
        {
        title: 'custom - landfinder',
        organization_id: '688265c89564a97aa04c2e58',
        private: true,
        label: 'Landfinder',
        img: '/images/maps/custom.png',
        mapId:'d50fba41eb3b81148457baa0'
    },
    {
        title: 'custom',
        label: 'Custom',
        img: '/images/maps/custom.png',
    },
];

interface MapStyleDetailType {
    [key: string]: any[] | undefined
};

export const MAP_STYLE_DETAILS: MapStyleDetailType = {
    standard: undefined,
    custom: [],
    satellite: undefined,
    hybrid: undefined,
    blue: [
        {
            'featureType': 'landscape.natural',
            'elementType': 'geometry.fill',
            'stylers': [{
                    'visibility': 'on'
                },
                {
                    'color': '#e0efef'
                }
            ]
        },
        {
            'featureType': 'poi',
            'elementType': 'all',
            'stylers': [{
                'visibility': 'off'
            }]
        },
        {
            'featureType': 'poi',
            'elementType': 'geometry.fill',
            'stylers': [{
                    'visibility': 'off'
                },
                {
                    'color': '#c0e8e8'
                }
            ]
        },
        {
            'featureType': 'road',
            'elementType': 'geometry',
            'stylers': [{
                    'lightness': 100
                },
                {
                    'visibility': 'simplified'
                }
            ]
        },
        {
            'featureType': 'road',
            'elementType': 'labels',
            'stylers': [{
                'visibility': 'on'
            }]
        },
        {
            'featureType': 'road',
            'elementType': 'labels.text',
            'stylers': [{
                    'visibility': 'on'
                },
                {
                    'lightness': '13'
                }
            ]
        },
        {
            'featureType': 'road',
            'elementType': 'labels.text.fill',
            'stylers': [{
                    'visibility': 'on'
                },
                {
                    'hue': '#17ff00'
                }
            ]
        },
        {
            'featureType': 'road.highway',
            'elementType': 'all',
            'stylers': [{
                'visibility': 'off'
            }]
        },
        {
            'featureType': 'road.arterial',
            'elementType': 'all',
            'stylers': [{
                'visibility': 'simplified'
            }]
        },
        {
            'featureType': 'road.local',
            'elementType': 'all',
            'stylers': [{
                'visibility': 'simplified'
            }]
        },
        {
            'featureType': 'transit',
            'elementType': 'all',
            'stylers': [{
                'visibility': 'off'
            }]
        },
        {
            'featureType': 'transit.line',
            'elementType': 'all',
            'stylers': [{
                'visibility': 'on'
            }]
        },
        {
            'featureType': 'transit.line',
            'elementType': 'geometry',
            'stylers': [{
                    'visibility': 'off'
                },
                {
                    'lightness': 700
                }
            ]
        },
        {
            'featureType': 'transit.line',
            'elementType': 'labels',
            'stylers': [{
                'visibility': 'simplified'
            }]
        },
        {
            'featureType': 'water',
            'elementType': 'all',
            'stylers': [{
                'color': '#7dcdcd'
            }]
        }
    ],
    paper: [
        {
            'featureType': 'administrative',
            'elementType': 'all',
            'stylers': [
                {
                    'visibility': 'simplified'
                },
                {
                    'lightness': '-7'
                },
                {
                    'saturation': '-34'
                }
            ]
        },
        {
            'featureType': 'administrative',
            'elementType': 'labels.text',
            'stylers': [
                {
                    'lightness': '38'
                }
            ]
        },
        {
            'featureType': 'landscape',
            'elementType': 'all',
            'stylers': [
                {
                    'visibility': 'simplified'
                },
                {
                    'saturation': 74
                },
                {
                    'lightness': '50'
                },
                {
                    'color': '#e6ebe3'
                }
            ]
        },
        {
            'featureType': 'poi',
            'elementType': 'all',
            'stylers': [
                {
                    'visibility': 'off'
                }
            ]
        },
        {
            'featureType': 'road',
            'elementType': 'all',
            'stylers': [
                {
                    'visibility': 'simplified'
                }
            ]
        },
        {
            'featureType': 'road.highway',
            'elementType': 'all',
            'stylers': [
                {
                    'visibility': 'simplified'
                },
                {
                    'weight': 0.6
                },
                {
                    'saturation': -85
                },
                {
                    'lightness': 61
                }
            ]
        },
        {
            'featureType': 'road.highway',
            'elementType': 'geometry',
            'stylers': [
                {
                    'visibility': 'on'
                }
            ]
        },
        {
            'featureType': 'road.highway',
            'elementType': 'geometry.stroke',
            'stylers': [
                {
                    'color': '#d4c8c8'
                }
            ]
        },
        {
            'featureType': 'road.highway.controlled_access',
            'elementType': 'all',
            'stylers': [
                {
                    'visibility': 'simplified'
                }
            ]
        },
        {
            'featureType': 'road.arterial',
            'elementType': 'all',
            'stylers': [
                {
                    'visibility': 'simplified'
                }
            ]
        },
        {
            'featureType': 'road.arterial',
            'elementType': 'geometry.stroke',
            'stylers': [
                {
                    'color': '#d4c8c8'
                }
            ]
        },
        {
            'featureType': 'road.local',
            'elementType': 'all',
            'stylers': [
                {
                    'visibility': 'simplified'
                }
            ]
        },
        {
            'featureType': 'road.local',
            'elementType': 'geometry',
            'stylers': [
                {
                    'visibility': 'simplified'
                }
            ]
        },
        {
            'featureType': 'road.local',
            'elementType': 'geometry.fill',
            'stylers': [
                {
                    'color': '#f8e5e5'
                },
                {
                    'visibility': 'on'
                }
            ]
        },
        {
            'featureType': 'road.local',
            'elementType': 'geometry.stroke',
            'stylers': [
                {
                    'visibility': 'simplified'
                },
                {
                    'saturation': '-5'
                },
                {
                    'lightness': '21'
                }
            ]
        },
        {
            'featureType': 'transit',
            'elementType': 'all',
            'stylers': [
                {
                    'visibility': 'off'
                }
            ]
        },
        {
            'featureType': 'water',
            'elementType': 'all',
            'stylers': [
                {
                    'visibility': 'simplified'
                },
                {
                    'color': '#5f94ff'
                },
                {
                    'lightness': '-24'
                },
                {
                    'gamma': 5.86
                },
                {
                    'saturation': '44'
                }
            ]
        }
    ],
    muted: [
        {
            'featureType': 'all',
            'elementType': 'geometry.fill',
            'stylers': [
                {
                    'weight': '2.00'
                }
            ]
        },
        {
            'featureType': 'all',
            'elementType': 'geometry.stroke',
            'stylers': [
                {
                    'color': '#9c9c9c'
                }
            ]
        },
        {
            'featureType': 'all',
            'elementType': 'labels.text',
            'stylers': [
                {
                    'visibility': 'on'
                }
            ]
        },
        {
            'featureType': 'landscape',
            'elementType': 'all',
            'stylers': [
                {
                    'color': '#f2f2f2'
                }
            ]
        },
        {
            'featureType': 'landscape',
            'elementType': 'geometry.fill',
            'stylers': [
                {
                    'color': '#ffffff'
                }
            ]
        },
        {
            'featureType': 'landscape.man_made',
            'elementType': 'geometry.fill',
            'stylers': [
                {
                    'color': '#ffffff'
                }
            ]
        },
        {
            'featureType': 'poi',
            'elementType': 'all',
            'stylers': [
                {
                    'visibility': 'off'
                }
            ]
        },
        {
            'featureType': 'road',
            'elementType': 'all',
            'stylers': [
                {
                    'saturation': -100
                },
                {
                    'lightness': 45
                }
            ]
        },
        {
            'featureType': 'road',
            'elementType': 'geometry.fill',
            'stylers': [
                {
                    'color': '#eeeeee'
                }
            ]
        },
        {
            'featureType': 'road',
            'elementType': 'labels.text.fill',
            'stylers': [
                {
                    'color': '#7b7b7b'
                }
            ]
        },
        {
            'featureType': 'road',
            'elementType': 'labels.text.stroke',
            'stylers': [
                {
                    'color': '#ffffff'
                }
            ]
        },
        {
            'featureType': 'road.highway',
            'elementType': 'all',
            'stylers': [
                {
                    'visibility': 'simplified'
                }
            ]
        },
        {
            'featureType': 'road.arterial',
            'elementType': 'labels.icon',
            'stylers': [
                {
                    'visibility': 'off'
                }
            ]
        },
        {
            'featureType': 'transit',
            'elementType': 'all',
            'stylers': [
                {
                    'visibility': 'off'
                }
            ]
        },
        {
            'featureType': 'water',
            'elementType': 'all',
            'stylers': [
                {
                    'color': '#46bcec'
                },
                {
                    'visibility': 'on'
                }
            ]
        },
        {
            'featureType': 'water',
            'elementType': 'geometry.fill',
            'stylers': [
                {
                    'color': '#c8d7d4'
                }
            ]
        },
        {
            'featureType': 'water',
            'elementType': 'labels.text.fill',
            'stylers': [
                {
                    'color': '#070707'
                }
            ]
        },
        {
            'featureType': 'water',
            'elementType': 'labels.text.stroke',
            'stylers': [
                {
                    'color': '#ffffff'
                }
            ]
        }
    ],
    bright: [
        {
            'featureType': 'all',
            'elementType': 'all',
            'stylers': [
                {
                    'saturation': '32'
                },
                {
                    'lightness': '-3'
                },
                {
                    'visibility': 'on'
                },
                {
                    'weight': '1.18'
                }
            ]
        },
        {
            'featureType': 'administrative',
            'elementType': 'all',
            'stylers': [
                {
                    'visibility': 'simplified'
                }
            ]
        },
        {
            'featureType': 'administrative',
            'elementType': 'labels',
            'stylers': [
                {
                    'visibility': 'simplified'
                },
                {
                    'lightness': '8'
                }
            ]
        },
        {
            'featureType': 'landscape',
            'elementType': 'labels',
            'stylers': [
                {
                    'visibility': 'off'
                }
            ]
        },
        {
            'featureType': 'landscape.man_made',
            'elementType': 'all',
            'stylers': [
                {
                    'saturation': '-70'
                },
                {
                    'lightness': '14'
                }
            ]
        },
        {
            'featureType': 'poi',
            'elementType': 'labels',
            'stylers': [
                {
                    'visibility': 'off'
                }
            ]
        },
        {
            'featureType': 'road',
            'elementType': 'labels',
            'stylers': [
                {
                    'visibility': 'simplified'
                }
            ]
        },
        {
            'featureType': 'transit',
            'elementType': 'all',
            'stylers': [
                {
                    'visibility': 'simplified'
                }
            ]
        },
        {
            'featureType': 'transit',
            'elementType': 'labels',
            'stylers': [
                {
                    'visibility': 'off'
                }
            ]
        },
        {
            'featureType': 'water',
            'elementType': 'all',
            'stylers': [
                {
                    'saturation': '100'
                },
                {
                    'lightness': '-14'
                }
            ]
        },
        {
            'featureType': 'water',
            'elementType': 'labels',
            'stylers': [
                {
                    'visibility': 'off'
                },
                {
                    'lightness': '12'
                }
            ]
        }
    ],
    sketch: [
        {
            'featureType': 'all',
            'elementType': 'geometry',
            'stylers': [
                {
                    'visibility': 'off'
                }
            ]
        },
        {
            'featureType': 'all',
            'elementType': 'labels',
            'stylers': [
                {
                    'visibility': 'off'
                }
            ]
        },
        {
            'featureType': 'administrative',
            'elementType': 'labels',
            'stylers': [
                {
                    'visibility': 'simplified'
                }
            ]
        },
        {
            'featureType': 'administrative.country',
            'elementType': 'all',
            'stylers': [
                {
                    'visibility': 'on'
                }
            ]
        },
        {
            'featureType': 'administrative.country',
            'elementType': 'geometry',
            'stylers': [
                {
                    'visibility': 'on'
                },
                {
                    'gamma': '1.73'
                }
            ]
        },
        {
            'featureType': 'administrative.province',
            'elementType': 'geometry',
            'stylers': [
                {
                    'visibility': 'on'
                }
            ]
        },
        {
            'featureType': 'administrative.locality',
            'elementType': 'geometry',
            'stylers': [
                {
                    'visibility': 'on'
                }
            ]
        },
        {
            'featureType': 'administrative.land_parcel',
            'elementType': 'geometry',
            'stylers': [
                {
                    'visibility': 'off'
                }
            ]
        },
        {
            'featureType': 'landscape',
            'elementType': 'all',
            'stylers': [
                {
                    'color': '#ffffff'
                },
                {
                    'visibility': 'on'
                }
            ]
        },
        {
            'featureType': 'road',
            'elementType': 'geometry',
            'stylers': [
                {
                    'visibility': 'on'
                },
                {
                    'color': '#000000'
                },
                {
                    'lightness': '20'
                },
                {
                    'gamma': '0.00'
                },
                {
                    'weight': '0.47'
                }
            ]
        },
        {
            'featureType': 'road',
            'elementType': 'labels',
            'stylers': [
                {
                    'visibility': 'simplified'
                },
                {
                    'lightness': '-86'
                },
                {
                    'weight': '1.08'
                }
            ]
        },
        {
            'featureType': 'road.highway',
            'elementType': 'all',
            'stylers': [
                {
                    'visibility': 'simplified'
                }
            ]
        },
        {
            'featureType': 'road.highway',
            'elementType': 'labels',
            'stylers': [
                {
                    'visibility': 'off'
                }
            ]
        },
        {
            'featureType': 'road.highway.controlled_access',
            'elementType': 'labels',
            'stylers': [
                {
                    'visibility': 'off'
                }
            ]
        },
        {
            'featureType': 'road.arterial',
            'elementType': 'labels',
            'stylers': [
                {
                    'visibility': 'off'
                }
            ]
        },
        {
            'featureType': 'road.local',
            'elementType': 'all',
            'stylers': [
                {
                    'visibility': 'simplified'
                }
            ]
        },
        {
            'featureType': 'road.local',
            'elementType': 'geometry.fill',
            'stylers': [
                {
                    'gamma': '2.52'
                },
                {
                    'lightness': '-65'
                },
                {
                    'weight': '0.3'
                }
            ]
        },
        {
            'featureType': 'road.local',
            'elementType': 'geometry.stroke',
            'stylers': [
                {
                    'gamma': '0.94'
                },
                {
                    'lightness': '-3'
                },
                {
                    'weight': '1.50'
                }
            ]
        },
        {
            'featureType': 'road.local',
            'elementType': 'labels',
            'stylers': [
                {
                    'visibility': 'simplified'
                }
            ]
        }
    ],
    explorer: [
        {
            'featureType': 'administrative',
            'elementType': 'all',
            'stylers': [
                {
                    'hue': '#3a3935'
                },
                {
                    'saturation': 5
                },
                {
                    'lightness': -57
                },
                {
                    'visibility': 'off'
                }
            ]
        },
        {
            'featureType': 'administrative.province',
            'elementType': 'all',
            'stylers': [
                {
                    'hue': '#ffffff'
                },
                {
                    'lightness': 100
                },
                {
                    'visibility': 'simplified'
                }
            ]
        },
        {
            'featureType': 'administrative.locality',
            'elementType': 'labels',
            'stylers': [
                {
                    'hue': '#ffffff'
                },
                {
                    'lightness': 100
                },
                {
                    'visibility': 'off'
                }
            ]
        },
        {
            'featureType': 'administrative.neighborhood',
            'elementType': 'all',
            'stylers': [
                {
                    'hue': '#ffffff'
                },
                {
                    'lightness': 100
                },
                {
                    'visibility': 'off'
                }
            ]
        },
        {
            'featureType': 'administrative.land_parcel',
            'elementType': 'all',
            'stylers': [
                {
                    'hue': '#ffffff'
                },
                {
                    'lightness': 100
                },
                {
                    'visibility': 'off'
                }
            ]
        },
        {
            'featureType': 'landscape',
            'elementType': 'geometry',
            'stylers': [
                {
                    'hue': '#b7caaa'
                },
                {
                    'saturation': -14
                },
                {
                    'lightness': -18
                },
                {
                    'visibility': 'on'
                }
            ]
        },
        {
            'featureType': 'landscape.man_made',
            'elementType': 'all',
            'stylers': [
                {
                    'hue': '#cbdac1'
                },
                {
                    'saturation': -6
                },
                {
                    'lightness': -9
                },
                {
                    'visibility': 'on'
                }
            ]
        },
        {
            'featureType': 'poi',
            'elementType': 'all',
            'stylers': [
                {
                    'visibility': 'off'
                }
            ]
        },
        {
            'featureType': 'poi',
            'elementType': 'geometry',
            'stylers': [
                {
                    'hue': '#c17118'
                },
                {
                    'saturation': 61
                },
                {
                    'lightness': -45
                },
                {
                    'visibility': 'on'
                }
            ]
        },
        {
            'featureType': 'poi.medical',
            'elementType': 'all',
            'stylers': [
                {
                    'visibility': 'off'
                }
            ]
        },
        {
            'featureType': 'poi.medical',
            'elementType': 'geometry',
            'stylers': [
                {
                    'hue': '#ffcb00'
                },
                {
                    'saturation': 50
                },
                {
                    'lightness': -46
                },
                {
                    'visibility': 'on'
                }
            ]
        },
        {
            'featureType': 'poi.park',
            'elementType': 'all',
            'stylers': [
                {
                    'hue': '#6cff00'
                },
                {
                    'saturation': -46
                },
                {
                    'lightness': -28
                },
                {
                    'visibility': 'simplified'
                }
            ]
        },
        {
            'featureType': 'road',
            'elementType': 'geometry',
            'stylers': [
                {
                    'hue': '#8d9b83'
                },
                {
                    'saturation': -89
                },
                {
                    'lightness': -12
                },
                {
                    'visibility': 'on'
                }
            ]
        },
        {
            'featureType': 'road.highway',
            'elementType': 'geometry',
            'stylers': [
                {
                    'hue': '#d4dad0'
                },
                {
                    'saturation': -88
                },
                {
                    'lightness': 54
                },
                {
                    'visibility': 'simplified'
                }
            ]
        },
        {
            'featureType': 'road.arterial',
            'elementType': 'geometry',
            'stylers': [
                {
                    'hue': '#bdc5b6'
                },
                {
                    'saturation': -89
                },
                {
                    'lightness': -3
                },
                {
                    'visibility': 'simplified'
                }
            ]
        },
        {
            'featureType': 'road.local',
            'elementType': 'geometry',
            'stylers': [
                {
                    'hue': '#bdc5b6'
                },
                {
                    'saturation': -89
                },
                {
                    'lightness': -26
                },
                {
                    'visibility': 'on'
                }
            ]
        },
        {
            'featureType': 'transit',
            'elementType': 'all',
            'stylers': [
                {
                    'visibility': 'off'
                }
            ]
        },
        {
            'featureType': 'transit',
            'elementType': 'geometry',
            'stylers': [
                {
                    'hue': '#a43218'
                },
                {
                    'saturation': 74
                },
                {
                    'lightness': -51
                },
                {
                    'visibility': 'simplified'
                }
            ]
        },
        {
            'featureType': 'water',
            'elementType': 'geometry',
            'stylers': [
                {
                    'hue': '#165c64'
                },
                {
                    'saturation': 34
                },
                {
                    'lightness': -69
                },
                {
                    'visibility': 'on'
                }
            ]
        }
    ],
    love: [
        {
            'featureType': 'administrative',
            'elementType': 'labels.text.fill',
            'stylers': [
                {
                    'gamma': '1.42'
                },
                {
                    'lightness': '11'
                },
                {
                    'saturation': '-100'
                }
            ]
        },
        {
            'featureType': 'administrative',
            'elementType': 'labels.text.stroke',
            'stylers': [
                {
                    'visibility': 'off'
                }
            ]
        },
        {
            'featureType': 'administrative.country',
            'elementType': 'geometry.stroke',
            'stylers': [
                {
                    'lightness': -5
                },
                {
                    'color': '#b0b0b0'
                },
                {
                    'weight': 1.7
                }
            ]
        },
        {
            'featureType': 'administrative.country',
            'elementType': 'labels.text.stroke',
            'stylers': [
                {
                    'visibility': 'off'
                }
            ]
        },
        {
            'featureType': 'administrative.province',
            'elementType': 'all',
            'stylers': [
                {
                    'visibility': 'off'
                }
            ]
        },
        {
            'featureType': 'landscape',
            'elementType': 'geometry',
            'stylers': [
                {
                    'hue': '#ff0000'
                },
                {
                    'lightness': '0'
                },
                {
                    'saturation': '70'
                }
            ]
        },
        {
            'featureType': 'poi',
            'elementType': 'all',
            'stylers': [
                {
                    'visibility': 'off'
                }
            ]
        },
        {
            'featureType': 'poi',
            'elementType': 'geometry',
            'stylers': [
                {
                    'color': '#FFB3B3'
                }
            ]
        },
        {
            'featureType': 'poi',
            'elementType': 'labels.text.stroke',
            'stylers': [
                {
                    'visibility': 'off'
                }
            ]
        },
        {
            'featureType': 'road',
            'elementType': 'all',
            'stylers': [
                {
                    'visibility': 'simplified'
                }
            ]
        },
        {
            'featureType': 'road',
            'elementType': 'labels.text.stroke',
            'stylers': [
                {
                    'visibility': 'off'
                }
            ]
        },
        {
            'featureType': 'road.highway',
            'elementType': 'all',
            'stylers': [
                {
                    'color': '#FFB3B3'
                }
            ]
        },
        {
            'featureType': 'road.arterial',
            'elementType': 'all',
            'stylers': [
                {
                    'visibility': 'on'
                },
                {
                    'color': '#ffb3b3'
                }
            ]
        },
        {
            'featureType': 'road.local',
            'elementType': 'all',
            'stylers': [
                {
                    'visibility': 'simplified'
                }
            ]
        },
        {
            'featureType': 'transit',
            'elementType': 'all',
            'stylers': [
                {
                    'visibility': 'off'
                }
            ]
        },
        {
            'featureType': 'transit',
            'elementType': 'labels.text.stroke',
            'stylers': [
                {
                    'visibility': 'off'
                }
            ]
        },
        {
            'featureType': 'water',
            'elementType': 'geometry',
            'stylers': [
                {
                    'color': '#FFB3B3'
                },
                {
                    'lightness': 66
                }
            ]
        },
        {
            'featureType': 'water',
            'elementType': 'labels.text.stroke',
            'stylers': [
                {
                    'visibility': 'off'
                }
            ]
        }
    ]
};

export const STOP_WORDS = [
    'a',
    'also',
    'an',
    'and',
    'are',
    'as',
    'at',
    'be',
    'because',
    'been',
    'but',
    'by',
    'establishment',
    'for',
    'from',
    'has',
    'have',
    'however',
    'if',
    'in',
    'interest',
    'is',
    'it',
    'its',
    'map',
    'my',
    'not',
    'null',
    'of',
    'on',
    'or',
    'place',
    'point',
    'so',
    'than',
    'that',
    'the',
    'their',
    'there',
    'these',
    'this',
    'to',
    'was',
    'were',
    'whatever',
    'whether',
    'which',
    'with',
    'would'
];

// SMS Constants and Templates
export const SMS_CHARACTER_LIMIT = 160; // Standard SMS character limit
export const SMS_LONG_MESSAGE_SEGMENT_LIMIT = 153; // Each segment in a concatenated SMS
export const SMS_MAX_SEGMENTS = 3; // Maximum number of SMS segments we'll allow
export const SMS_EFFECTIVE_MAX_LENGTH = SMS_LONG_MESSAGE_SEGMENT_LIMIT * SMS_MAX_SEGMENTS; // 459 characters

// SMS Templates for various events
export const SMS_TEMPLATES = {
    CHALLENGE_REGISTRATION: {
        subject: 'Welcome to {{challenge_name}}!',
        body: 'Thanks for joining {{challenge_name}}! Start exploring and earn points by visiting locations. Your unique link: {{unique_link}}'
    },
    CHALLENGE_REWARD_EARNED: {
        subject: 'Reward Earned: {{reward_name}}',
        body: 'Congratulations! You\'ve earned "{{reward_name}}" in {{challenge_name}}. Keep exploring for more rewards! {{unique_link}}'
    },
    CHALLENGE_LOCATION_CHECKIN: {
        subject: 'Location Check-in Confirmed',
        body: 'Great job checking in at {{location_name}}! You\'ve earned {{points}} points in {{challenge_name}}. {{unique_link}}'
    },
    CHALLENGE_CHECKIN_APPROVED: {
        subject: 'Check-in Approved!',
        body: 'Your check-in at {{location_name}} has been approved! Points added to your {{challenge_name}} total. {{unique_link}}'
    },
    CHALLENGE_ACTIVITY_APPROVED: {
        subject: 'Activity Approved!',
        body: 'Your {{activity_name}} submission has been approved! {{points}} points added to {{challenge_name}}. {{unique_link}}'
    },
    FORM_SUBMISSION_CREATED: {
        subject: 'Submission Received',
        body: 'Thanks for your submission to {{map_name}}! Your point "{{point_name}}" has been added. {{unique_link}}'
    },
    FORM_SUBMISSION_APPROVED: {
        subject: 'Submission Approved!',
        body: 'Your submission "{{point_name}}" to {{map_name}} has been approved! {{unique_link}}'
    },
    FORM_SUBMISSION_UPDATED: {
        subject: 'Submission Updated',
        body: 'Your submission "{{point_name}}" in {{map_name}} has been updated. {{unique_link}}'
    },
    FORM_SUBMISSION_DELETED: {
        subject: 'Submission Removed',
        body: 'Your submission "{{point_name}}" has been removed from {{map_name}}. Contact us if you have questions.'
    },
    SCHEDULED_MESSAGE: {
        subject: 'Message from {{organization_name}}',
        body: 'Hello! {{custom_message}} Reply STOP to opt out of messages.'
    }
};

// SMS Opt-in compliance messages
export const SMS_OPT_IN_MESSAGES = {
    CONFIRMATION: 'You\'ve opted in to receive SMS updates. Reply STOP to unsubscribe anytime. Msg & data rates may apply.',
    STOP_RESPONSE: 'You\'ve been unsubscribed from SMS messages. Reply START to re-subscribe.',
    HELP_RESPONSE: 'For help, visit our website or contact support. Reply STOP to unsubscribe.',
    INVALID_PHONE: 'Invalid phone number format. Please provide a valid phone number with country code (e.g., +1234567890).'
};

// Countries that commonly use different SMS character limits or encoding
export const INTERNATIONAL_SMS_CONSIDERATIONS = {
    // Countries with specific SMS regulations or character encoding requirements
    UNICODE_HEAVY_COUNTRIES: ['CN', 'JP', 'KR', 'IN', 'TH', 'VN'], // Countries likely to use Unicode characters
    STRICT_SMS_REGULATIONS: ['US', 'CA', 'GB', 'AU'], // Countries with strict SMS compliance requirements
    CHARACTER_LIMIT_VARIATIONS: {
        UNICODE: 70, // Unicode SMS character limit per segment
        GSM_7BIT: 160 // Standard GSM 7-bit character limit
    }
};

export const DEFAULT_CATEGORY_ICON = 'https://img.icons8.com/stickers/marker.png';

export const DEFAULT_ICON_SIZE = 20;

export const DEFAULT_EMAIL_COLLECTION_POPUP: PopUpCustomization = {
    cta_text_color: '#000000',
    cta_background_color: '#4CAF50',
    text_color: '#000000',
    background_color: '#FFDAB9',
    is_active: false,
    pop_up_header: 'Subscribe to our newsletter!',
    pop_up_description: 'Get the latest news and updates from our company. This would appear on your public map!',
    cta_button_text: 'Sign Up',
    opt_in_language: 'I agree to receive emails.',
    display_when_embeded: true,
    display_number: 20,
    pop_up_type: PopUpTypeOld.LeadGeneration,
    display_once: true,
    organization_id: { $oid: '' },
    entity_ids: [],
    collect_email: true,
};

export const DEFAULT_POST_SUBMIT_POPUP: PopUpCustomization = {
    cta_text_color: '#000000',
    cta_background_color: '#4CAF50',
    text_color: '#000000',
    background_color: '#FFDAB9',
    is_active: false,
    pop_up_header: 'Thanks for submitting a point!',
    pop_up_description: 'Keep in touch by subscribing at the following link',
    cta_button_text: 'Go to our website',
    cta_link: 'https://www.proxi.co',
    collect_email: false,
    opt_in_language: 'I agree to receive emails.',
    display_when_embeded: true,
    display_number: 0,
    pop_up_type: PopUpTypeOld.PostPointSubmission,
    display_once: false,
    organization_id: { $oid: '' },
    entity_ids: [],
};

export const DEFAULT_POINT_EMAIL_COLLECTION_SETTINGS: PointEmailCaptureCustomization = {
    is_active: false,
    cta_button_text: 'Inquire Now',
    success_message: 'Thank you for your interest! We will be in touch shortly.',
    destination_email: '',
    destination_type: 'static_email',
    custom_field_id: undefined,
    name_field: {
        name: 'name',
        label: 'Name',
        field_type: FormFieldType.Text,
        is_required: false,
        is_active: false,
        placeholder: 'Enter your name',

    },
    email_field: {
        name: 'email',
        label: 'Email',
        field_type: FormFieldType.Email,
        is_required: true,
        is_active: true,
        placeholder: 'Enter your email',
    },
    phone_field: {
        name: 'phone',
        label: 'Phone',
        field_type: FormFieldType.Phone,
        is_required: false,
        is_active: false,
        placeholder: 'Enter your phone number',
    },
    additional_info_field: {
        name: 'additional_info',
        label: 'Additional Info',
        field_type: FormFieldType.TextArea,
        is_required: false,
        is_active: false,
        placeholder: 'Enter any additional information',
    },
};

export const IFRAME_TEMPLATE = '<iframe src="@@@@@" allow="geolocation; clipboard-write" width="100%" height="625px" style="border-width: 0px;" allowfullscreen></iframe>';
export const POWERED_BY_EMBED = '<div style="font-family: Sans-Serif; font-size:12px;color:#000000;opacity:0.5; padding-top: 5px;"> powered by <a href="https://www.proxi.co/?utm_source=embed&utm_medium=referral&utm_content=powered_by" style="color:#000000" target="_blank" rel="noopener noreferrer">Proxi</a> </div>';


export const DEFAULT_CHALLENGE_REWARD_ICON = 'https://img.icons8.com/tiny-color/trophy.png';
export const DEFAULT_CHALLENGE_REWARD_TITLE = 'Challenge Completion';
export const DEFAULT_CHALLENGE_ACTIVITY_ICON = 'https://img.icons8.com/?size=48&id=OFHwDWASQWmX&format=png';
export const DEFAULT_CHALLENGE_ACTIVITY_TITLE = 'Submit a Picture';
export const DEFAULT_CHALLENGE_ACTIVITY_DESCRIPTION = 'Take a picture of yourself doing the challenge and submit it for extra points!';
export const DEFAULT_PASSPORT_REGISTRATION_SETTINGS: RegistrationSettings = {
    heading: 'Register for this Passport',
    description: 'Sign up to participate in this passport and earn points!',
    button_label: 'Register',
    logo_url: undefined,
    cover_image_url: 'https://images.pexels.com/photos/773471/pexels-photo-773471.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    email_required: true,
    show_email: true,
    phone_required: false,
    show_phone: true,
    username_required: false,
    show_logo_background: true,
    opt_in_required: false,
    payment_details: 'Free',
    additional_fields: []
};
export const DEFAULT_GUIDES_REGISTRATION_SETTINGS: RegistrationSettings = {
    heading: 'Register for your access to this Guide',
    description: 'Sign up to view this guide and explore the points of interest!',
    button_label: 'Register',
    logo_url: undefined,
    cover_image_url: 'https://images.pexels.com/photos/773471/pexels-photo-773471.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    email_required: true,
    show_email: true,
    phone_required: false,
    show_phone: true,
    username_required: false,
    opt_in_required: false,
    show_logo_background: true,
    payment_details: 'Free',
    additional_fields: []
};
export const DEFAULT_SCAVENGER_HUNT_REGISTRATION_SETTINGS: RegistrationSettings = {
    heading: 'Register for this Scavenger Hunt',
    description: 'Sign up to participate in this scavenger hunt and earn points!',
    button_label: 'Register',
    logo_url: undefined,
    cover_image_url: 'https://images.pexels.com/photos/773471/pexels-photo-773471.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    email_required: true,
    show_email: true,
    phone_required: false,
    show_phone: true,
    username_required: false,
    opt_in_required: false,
    payment_details: undefined,
    show_logo_background: true,
    additional_fields: []
};

export const DEFAULT_SCAVENGER_HUNT_SETTINGS: ScavengerHuntSettings = {
    display_one_clue_at_a_time: true,
    hint_use_deduction: 1,
    give_up_behavior: 'skip_location',
};

export const DEFAULT_TREASURE_HUNT_REGISTRATION_SETTINGS: RegistrationSettings = {
    heading: 'Register for this Treasure Hunt',
    description: 'Sign up to participate in this treasure hunt and discover hidden locations!',
    button_label: 'Register',
    logo_url: undefined,
    cover_image_url: 'https://images.pexels.com/photos/773471/pexels-photo-773471.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    email_required: true,
    show_email: true,
    phone_required: false,
    show_phone: true,
    username_required: false,
    opt_in_required: false,
    show_logo_background: true,
    payment_details: undefined,
    additional_fields: []
};

export const DEFAULT_CHALLENGE_REWARDS: CreateChallengeRewardRequest[] = [
    {
        title: 'First Place Award',
        description: 'Check into 1 location',
        image_url: 'https://img.icons8.com/color/prize.png',
        reward_criteria: RewardCriteria.NumberOfPlaces,
        reward_criteria_threshold: 1,
        selected_category_or_tag_id: undefined,
        selected_location_id: undefined,
        completion_message: 'Congrats! You\'ve visited your first location! Keep exploring for more delicious rewards!',
    }
];

export const DEFAULT_CHALLENGE_ACTIVITIES: ChallengeActivity[] = [
    {
        name: 'Snap a Selfie',
        description: 'Take a picture of yourself doing the challenge and submit it for extra points!',
        image_url: 'https://img.icons8.com/?size=48&id=OFHwDWASQWmX&format=png',
        point_value: 1,
        max_redemptions: 1,
        submission_type: 'photos'
    },
    {
        name: 'Rate the Plate',
        description: 'Leave a fun review of a meal, and earn extra points!',
        image_url: 'https://img.icons8.com/?size=48&id=OFHwDWASQWmX&format=png',
        point_value: 1,
        max_redemptions: 1,
        submission_type: 'text'
    }
];

export const TIER_TABLE = [
    {
        tierName: 'Pro',
        freeTrialDays: 7,
        tierLevel: FeatureTierLevel.ProBase,
        tierPriceAnnual: FeatureTierMonthlyPriceMap[FeatureTierLevel.ProBase].Annual,
        tierPriceMonthly: FeatureTierMonthlyPriceMap[FeatureTierLevel.ProBase].Monthly,
        tierDescription: 'For the professional map maker'
    }
];

export const TIER_FEATURES = [
    {
        featureName: 'userSeats',
        prettyName: 'User Seats',
        tiers: {
            Pro: 1,
        },
        type: 'number'
    },
    {
        featureName: 'pointsPerMap',
        prettyName: 'Points Per Map',
        tiers: {
            Pro: '1,000',
        },
        type: 'number',
        featureType: [FeatureType.PointsPerMap]
    },
    {
        featureName: 'monthlyEngagedVisitors',
        prettyName: 'Monthly Engaged Visitors Per Account',
        tiers: {
            Pro: '10,000',
        },
        type: 'number',
        info_url: 'https://www.proxi.co/pricing',
        featureType: [FeatureType.MonthlyAdFreeViewsPerMap]
    },
    {
        featureName: 'monthly AI Uses',
        prettyName: 'Monthly Uses of Proxi AI',
        tiers: {
            Pro: '25',
        },
        type: 'number',
        featureType: [FeatureType.NumberOfUsesOfProxiAI]
    },
    {
        featureName: 'customStyling',
        prettyName: 'Custom Styling',
        tiers: {
            Pro: true,
        },
        featureType: [FeatureType.MapStyling, FeatureType.HeaderLinkOut, FeatureType.HeaderLogo, FeatureType.CustomShapes]
    },
    {
        featureName: 'shareAnywhere',
        prettyName: 'Share Anywhere',
        tiers: {
            Pro: true,
        },
        featureType: [FeatureType.ShareMap, FeatureType.AddMapEditors, FeatureType.PrintableMap]
    },
    {
        featureName: 'insights',
        prettyName: 'Map Insights',
        tiers: {
            Pro: true,
        },
        featureType: [FeatureType.AdvancedInsights]
    },
    {
        featureName: 'customCrowdsourcingForm',
        prettyName: 'Custom Crowdsourcing Form',
        tiers: {
            Pro: true,
        },
        featureType: [FeatureType.CustomizeAddPointForm]
    },
    {
        featureName: 'mapButtonCustomization',
        prettyName: 'Map Button Customization',
        tiers: {
            Pro: true,
        },
        featureType: [FeatureType.DisableAlsoFeaturedOn, FeatureType.CustomizeAddPointForm, FeatureType.HideBuildYourOwnMap,
        FeatureType.HideAllCommandCenterButtons, FeatureType.HideAddToMapInPoints, FeatureType.CustomizeAboutMapDrawer, FeatureType.HideGetRoute, FeatureType.HideMultiSelect,
        FeatureType.CustomFilteringOptions ]
    },
    {
        featureName: 'leadGeneration',
        prettyName: 'Lead Generation',
        tiers: {
            Pro: true,
        },
        featureType: [
            FeatureType.EmailCapture,
            FeatureType.EmailCaptureOnPoint
        ]
    },
    {
        featureName: 'dataIntegrations',
        prettyName: 'Zapier Integration',
        tiers: {
            Pro: true,
        },
        featureType: [FeatureType.ZapierAccess]
    },
    {
        featureName: 'passwordPaywall',
        prettyName: 'Password & Paywall Protection',
        tiers: {
            Pro: true,
        },
        featureType: [FeatureType.PasswordProtection, FeatureType.PaywallProtection]
    },
    {
        featureName: 'passportsChallenges',
        prettyName: 'Passport/ Challenges',
        tiers: {
            Pro: false,
        },
        featureType: [FeatureType.ChallengePassport]
    },
    {
        featureName: 'election',
        prettyName: 'Elections / Voting',
        tiers: {
            Pro: false,
        },
        featureType: [FeatureType.Election]
    },
    {
        featureName: 'coManageMapsWithTeam',
        prettyName: 'Shared Backpack and Branding With Your Team',
        tiers: {
            Pro: true,
        },
        featureType: [FeatureType.TeamSharedBackpack]
    }
];

export const googleTypesSearchArray: GooglePlaceTypeSearch[] = [
    {
        google_place_id: 'library',
        search_terms: [
            'Library',
            'Public Library'
        ],
        autocomplete_id: 'library'
    },
    {
        google_place_id: 'restaurant',
        search_terms: [
            'Restaurant',
            'Food'
        ],
        autocomplete_id: 'restaurant'
    },
    {
        google_place_id: 'bar',
        search_terms: [
            'Bar',
            'Pub'
        ],
        autocomplete_id: 'bar'
    },
    {
        google_place_id: 'electric_vehicle_charging_station',
        search_terms: [
            'Electric Vehicle Charging Station',
            'Charging Station',
            'EV Charging Station'
        ],
    },
    {
        google_place_id: 'grocery_store',
        search_terms: [
            'Grocery Store',
            'Grocery Shop'
        ],
    },
    {
        google_place_id: 'cafe',
        search_terms: [
            'Cafe',
            'Coffee Shop'
        ],
        autocomplete_id: 'cafe'
    },
    {
        google_place_id: 'gift_shop',
        search_terms: [
            'Gift Shop'
        ]
    },
    {
        google_place_id: 'playground',
        search_terms: [
            'Playground'
        ]
    },
    {
        google_place_id: 'country',
        search_terms: [
            'Country'
        ],
        icon: 'https://img.icons8.com/stickers/country.png',
        autocomplete_id: 'country'
    },
    {
        google_place_id: 'locality',
        search_terms: [
            'City',
            'Town'
        ],
        icon: 'https://img.icons8.com/stickers/city.png',
        autocomplete_id: 'locality'
    },
    {
        google_place_id: 'neighborhood',
        search_terms: [
            'Neighborhood',
            'Suburb'
        ],
        icon: 'https://img.icons8.com/stickers/city.png',
        autocomplete_id: 'neighborhood'
    },
    {
        google_place_id: 'postal_code',
        search_terms: [
            'Postal Code',
            'Zip Code'
        ],
        icon: 'https://img.icons8.com/stickers/city-hall.png',
        autocomplete_id: 'postal_code'
    },
    {
        google_place_id: 'school_district',
        search_terms: [
            'School District'
        ],
        icon: 'https://img.icons8.com/stickers/school-house.png'
    },
    {
        google_place_id: 'car_dealer',
        search_terms: [
            'Car Dealer',
            'Dealership',
            'Car Dealership'
        ],
        autocomplete_id: 'car_dealer'
    },
    {
        google_place_id: 'car_rental',
        search_terms: [
            'Car Rental',
            'Rental Car'
        ],
        autocomplete_id: 'car_rental'
    },
    {
        google_place_id: 'car_repair',
        search_terms: [
            'Car Repair',
            'Auto Repair'
        ],
        autocomplete_id: 'car_repair'
    },
    {
        google_place_id: 'car_wash',
        search_terms: [
            'Car Wash'
        ],
        autocomplete_id: 'car_wash'
    },
    {
        google_place_id: 'parking',
        search_terms: [
            'Parking',
            'Parking Lot'
        ],
        autocomplete_id: 'parking'
    },
    {
        google_place_id: 'rest_stop',
        search_terms: [
            'Rest Stop',
            'Rest Area'
        ]
    },
    {
        google_place_id: 'farm',
        search_terms: [
            'Farm'
        ]
    },
    {
        google_place_id: 'art_gallery',
        search_terms: [
            'Art Gallery'
        ],
        autocomplete_id: 'art_gallery'
    },
    {
        google_place_id: 'museum',
        search_terms: [
            'Museum'
        ],
        autocomplete_id: 'museum'
    },
    {
        google_place_id: 'performing_arts_theater',
        search_terms: [
            'Performing Arts Theater',
            'Theater',
            'Theatre'
        ]
    },
    {
        google_place_id: 'library',
        search_terms: [
            'Library',
            'Public Library'
        ],
        autocomplete_id: 'library'
    },
    {
        google_place_id: 'preschool',
        search_terms: [
            'Preschool',
            'Pre-School',
            'Daycare',
            'Day Care',
            'Childcare',
            'Child Care'
        ]
    },
    {
        google_place_id: 'primary_school',
        search_terms: [
            'Primary School',
            'Elementary School',
            'Grade School'
        ],
        autocomplete_id: 'primary_school'
    },
    {
        google_place_id: 'school',
        search_terms: [
            'All School Types',
            'School'
        ],
        autocomplete_id: 'school'
    },
    {
        google_place_id: 'secondary_school',
        search_terms: [
            'Secondary School',
            'High School'
        ],
        autocomplete_id: 'secondary_school'
    },
    {
        google_place_id: 'university',
        search_terms: [
            'University',
            'College'
        ],
        autocomplete_id: 'university'
    },
    {
        google_place_id: 'amusement_center',
        search_terms: [
            'Amusement Center',
            'Arcade',
            'Family Fun Center',
            'Fun Center'
        ]
    },
    {
        google_place_id: 'amusement_park',
        search_terms: [
            'Amusement Park',
            'Theme Park'
        ],
        autocomplete_id: 'amusement_park'
    },
    {
        google_place_id: 'aquarium',
        search_terms: [
            'Aquarium'
        ],
        autocomplete_id: 'aquarium'
    },
    {
        google_place_id: 'banquet_hall',
        search_terms: [
            'Banquet Hall',
            'Banquet',
            'Event Space',
            'Event Venue',
            'Event Hall'
        ]
    },
    {
        google_place_id: 'bowling_alley',
        search_terms: [
            'Bowling Alley',
            'Bowling'
        ],
        autocomplete_id: 'bowling_alley'
    },
    {
        google_place_id: 'casino',
        search_terms: [
            'Casino',
            'Gambling'
        ],
        autocomplete_id: 'casino'
    },
    {
        google_place_id: 'community_center',
        search_terms: [
            'Community Center',
            'Community Hall',
            'Community Space'
        ]
    },
    {
        google_place_id: 'convention_center',
        search_terms: [
            'Convention Center',
            'Convention Hall',
            'Convention Space'
        ]
    },
    {
        google_place_id: 'cultural_center',
        search_terms: [
            'Cultural Center',
            'Cultural Hall',
            'Cultural Space'
        ]
    },
    {
        google_place_id: 'dog_park',
        search_terms: [
            'Dog Park',
            'Dog Run'
        ]
    },
    {
        google_place_id: 'event_venue',
        search_terms: [
            'Event Venue',
            'Event Space',
            'Event Hall'
        ]
    },
    {
        google_place_id: 'hiking_area',
        search_terms: [
            'Hiking Area',
            'Hiking Trail',
            'Hiking'
        ]
    },
    {
        google_place_id: 'historical_landmark',
        search_terms: [
            'Historical Landmark',
            'Historic Landmark',
            'Landmark'
        ]
    },
    {
        google_place_id: 'marina',
        search_terms: [
            'Marina',
            'Boat Dock',
            'Boat Ramp'
        ]
    },
    {
        google_place_id: 'movie_rental',
        search_terms: [
            'Movie Rental',
            'Movie Store',
            'Video Store'
        ],
        autocomplete_id: 'movie_rental'
    },
    {
        google_place_id: 'movie_theater',
        search_terms: [
            'Movie Theater',
            'Movie Theatre',
            'Cinema'
        ],
        autocomplete_id: 'movie_theater'
    },
    {
        google_place_id: 'national_park',
        search_terms: [
            'National Park'
        ]
    },
    {
        google_place_id: 'night_club',
        search_terms: [
            'Night Club',
            'Nightclub',
            'Club'
        ],
        autocomplete_id: 'night_club'
    },
    {
        google_place_id: 'park',
        search_terms: [
            'Park',
            'Public Park',
            'City Park'
        ],
        autocomplete_id: 'park'
    },
    {
        google_place_id: 'tourist_attraction',
        search_terms: [
            'Tourist Attraction',
            'Tourist Spot',
            'Tourist Destination'
        ],
        autocomplete_id: 'tourist_attraction'
    },
    {
        google_place_id: 'visitor_center',
        search_terms: [
            'Visitor Center',
            'Visitor Centre'
        ]
    },
    {
        google_place_id: 'wedding_venue',
        search_terms: [
            'Wedding Venue',
            'Wedding Hall',
            'Wedding Space'
        ]
    },
    {
        google_place_id: 'zoo',
        search_terms: [
            'Zoo'
        ],
        autocomplete_id: 'zoo'
    },
    {
        google_place_id: 'accounting',
        search_terms: [
            'Accounting',
            'Accountant',
            'CPA'
        ],
        autocomplete_id: 'accounting'
    },
    {
        google_place_id: 'atm',
        search_terms: [
            'ATM'
        ],
        autocomplete_id: 'atm'
    },
    {
        google_place_id: 'bank',
        search_terms: [
            'Bank'
        ],
        autocomplete_id: 'bank'
    },
    {
        google_place_id: 'american_restaurant',
        search_terms: [
            'American Restaurant',
            'American Food'
        ]
    },
    {
        google_place_id: 'bakery',
        search_terms: [
            'Bakery',
            'Baker'
        ],
        autocomplete_id: 'bakery'
    },
    {
        google_place_id: 'barbecue_restaurant',
        search_terms: [
            'Barbecue Restaurant',
            'Barbecue Food',
            'BBQ Restaurant',
            'BBQ Food'
        ]
    },
    {
        google_place_id: 'brazilian_restaurant',
        search_terms: [
            'Brazilian Restaurant',
            'Brazilian Food'
        ]
    },
    {
        google_place_id: 'breakfast_restaurant',
        search_terms: [
            'Breakfast Restaurant',
            'Breakfast Food'
        ]
    },
    {
        google_place_id: 'brunch_restaurant',
        search_terms: [
            'Brunch Restaurant',
            'Brunch Food'
        ]
    },
    {
        google_place_id: 'chinese_restaurant',
        search_terms: [
            'Chinese Restaurant',
            'Chinese Food'
        ]
    },
    {
        google_place_id: 'coffee_shop',
        search_terms: [
            'Coffee Shop'
        ]
    },
    {
        google_place_id: 'fast_food_restaurant',
        search_terms: [
            'Fast Food Restaurant',
            'Fast Food'
        ]
    },
    {
        google_place_id: 'french_restaurant',
        search_terms: [
            'French Restaurant',
            'French Food'
        ]
    },
    {
        google_place_id: 'greek_restaurant',
        search_terms: [
            'Greek Restaurant',
            'Greek Food'
        ]
    },
    {
        google_place_id: 'hamburger_restaurant',
        search_terms: [
            'Hamburger Restaurant',
            'Hamburgers'
        ]
    },
    {
        google_place_id: 'ice_cream_shop',
        search_terms: [
            'Ice Cream Shop',
            'Ice Cream'
        ]
    },
    {
        google_place_id: 'indian_restaurant',
        search_terms: [
            'Indian Restaurant',
            'Indian Food'
        ]
    },
    {
        google_place_id: 'indonesian_restaurant',
        search_terms: [
            'Indonesian Restaurant',
            'Indonesian Food'
        ]
    },
    {
        google_place_id: 'italian_restaurant',
        search_terms: [
            'Italian Restaurant',
            'Italian Food'
        ]
    },
    {
        google_place_id: 'japanese_restaurant',
        search_terms: [
            'Japanese Restaurant',
            'Japanese Food'
        ]
    },
    {
        google_place_id: 'korean_restaurant',
        search_terms: [
            'Korean Restaurant',
            'Korean Food'
        ]
    },
    {
        google_place_id: 'lebanese_restaurant',
        search_terms: [
            'Lebanese Restaurant',
            'Lebanese Food'
        ]
    },
    {
        google_place_id: 'meal_delivery',
        search_terms: [
            'Meal Delivery',
            'Food Delivery'
        ],
        autocomplete_id: 'meal_delivery'
    },
    {
        google_place_id: 'meal_takeaway',
        search_terms: [
            'Meal Takeaway',
            'Takeout',
            'Take Out',
            'To Go Food',
            'To-Go Food'
        ],
        autocomplete_id: 'meal_takeaway'
    },
    {
        google_place_id: 'mediterranean_restaurant',
        search_terms: [
            'Mediterranean Restaurant',
            'Mediterranean Food'
        ]
    },
    {
        google_place_id: 'mexican_restaurant',
        search_terms: [
            'Mexican Restaurant',
            'Mexican Food'
        ]
    },
    {
        google_place_id: 'middle_eastern_restaurant',
        search_terms: [
            'Middle Eastern Restaurant',
            'Middle Eastern Food'
        ]
    },
    {
        google_place_id: 'pizza_restaurant',
        search_terms: [
            'Pizza Restaurant',
            'Pizza'
        ]
    },
    {
        google_place_id: 'ramen_restaurant',
        search_terms: [
            'Ramen Restaurant',
            'Ramen'
        ]
    },
    {
        google_place_id: 'sandwich_shop',
        search_terms: [
            'Sandwich Shop',
            'Sandwiches',
            'Subs'
        ]
    },
    {
        google_place_id: 'seafood_restaurant',
        search_terms: [
            'Seafood Restaurant',
            'Seafood'
        ]
    },
    {
        google_place_id: 'spanish_restaurant',
        search_terms: [
            'Spanish Restaurant',
            'Spanish Food'
        ]
    },
    {
        google_place_id: 'steak_house',
        search_terms: [
            'Steak House',
            'Steakhouse',
            'Steak'
        ]
    },
    {
        google_place_id: 'sushi_restaurant',
        search_terms: [
            'Sushi Restaurant',
            'Sushi',
            'Sashimi'
        ]
    },
    {
        google_place_id: 'thai_restaurant',
        search_terms: [
            'Thai Restaurant',
            'Thai Food'
        ]
    },
    {
        google_place_id: 'turkish_restaurant',
        search_terms: [
            'Turkish Restaurant',
            'Turkish Food'
        ]
    },
    {
        google_place_id: 'vegan_restaurant',
        search_terms: [
            'Vegan Restaurant',
            'Vegan Food'
        ]
    },
    {
        google_place_id: 'vegetarian_restaurant',
        search_terms: [
            'Vegetarian Restaurant',
            'Vegetarian Food'
        ]
    },
    {
        google_place_id: 'vietnamese_restaurant',
        search_terms: [
            'Vietnamese Restaurant',
            'Vietnamese Food'
        ]
    },
    {
        google_place_id: 'administrative_area_level_1',
        search_terms: [
            'State',
            'Province',
            'Region'
        ],
        icon: 'https://img.icons8.com/stickers/city-buildings.png',
        autocomplete_id: 'administrative_area_level_1'
    },
    {
        google_place_id: 'administrative_area_level_2',
        search_terms: [
            'County',
            'District'
        ],
        icon: 'https://img.icons8.com/stickers/city-buildings.png',
        autocomplete_id: 'administrative_area_level_2'
    },
    {
        google_place_id: 'administrative_area_level_3',
        search_terms: [
            'Sub-County',
            'Sub-District'
        ],
        icon: 'https://img.icons8.com/stickers/downtown.png',
        autocomplete_id: 'administrative_area_level_3'
    },
    {
        google_place_id: 'administrative_area_level_4',
        search_terms: [
            'Sub-Sub-County',
            'Sub-Sub-District'
        ],
        icon: 'https://img.icons8.com/stickers/downtown.png',
        autocomplete_id: 'administrative_area_level_4'
    },
    {
        google_place_id: 'city_hall',
        search_terms: [
            'City Hall',
            'Town Hall'
        ],
        icon: 'https://img.icons8.com/stickers/city-hall.png',
        autocomplete_id: 'city_hall'
    },
    {
        google_place_id: 'courthouse',
        search_terms: [
            'Courthouse'
        ],
        autocomplete_id: 'courthouse'
    },
    {
        google_place_id: 'embassy',
        search_terms: [
            'Embassy'
        ],
        autocomplete_id: 'embassy'
    },
    {
        google_place_id: 'fire_station',
        search_terms: [
            'Fire Station',
            'Fire Department'
        ],
        autocomplete_id: 'fire_station'
    },
    {
        google_place_id: 'local_government_office',
        search_terms: [
            'Local Government Office',
            'Government Office'
        ],
        autocomplete_id: 'local_government_office'
    },
    {
        google_place_id: 'police',
        search_terms: [
            'Police Station',
            'Police Department'
        ],
        autocomplete_id: 'police'
    },
    {
        google_place_id: 'post_office',
        search_terms: [
            'Post Office',
            'Mail Service'
        ],
        autocomplete_id: 'post_office'
    },
    {
        google_place_id: 'dental_clinic',
        search_terms: [
            'Dental Clinic',
            'Dentist'
        ]
    },
    {
        google_place_id: 'dentist',
        search_terms: [
            'Dentist'
        ],
        autocomplete_id: 'dentist'
    },
    {
        google_place_id: 'doctor',
        search_terms: [
            'Doctor',
            'Physician'
        ],
        autocomplete_id: 'doctor'
    },
    {
        google_place_id: 'drugstore',
        search_terms: [
            'Drugstore',
            'Pharmacy',
            'Pharmacist'
        ],
        autocomplete_id: 'drugstore'
    },
    {
        google_place_id: 'hospital',
        search_terms: [
            'Hospital',
            'Medical Center'
        ],
        autocomplete_id: 'hospital'
    },
    {
        google_place_id: 'medical_lab',
        search_terms: [
            'Medical Lab',
            'Lab'
        ]
    },
    {
        google_place_id: 'pharmacy',
        search_terms: [
            'Pharmacy',
            'Pharmacist',
            'Drugstore'
        ],
        autocomplete_id: 'pharmacy'
    },
    {
        google_place_id: 'physiotherapist',
        search_terms: [
            'Physiotherapist',
            'Physical Therapist',
            'Physical Therapy'
        ],
        autocomplete_id: 'physiotherapist'
    },
    {
        google_place_id: 'spa',
        search_terms: [
            'Spa',
            'Massage',
            'Massage Parlor'
        ],
        autocomplete_id: 'spa'
    },
    {
        google_place_id: 'bed_and_breakfast',
        search_terms: [
            'Bed and Breakfast',
            'B&B',
            'BnB'
        ]
    },
    {
        google_place_id: 'campground',
        search_terms: [
            'Campground',
            'Camping',
            'Camping Ground'
        ],
        autocomplete_id: 'campground'
    },
    {
        google_place_id: 'camping_cabin',
        search_terms: [
            'Camping Cabin',
            'Cabin'
        ]
    },
    {
        google_place_id: 'cottage',
        search_terms: [
            'Cottage'
        ]
    },
    {
        google_place_id: 'extended_stay_hotel',
        search_terms: [
            'Extended Stay Hotel',
            'Extended Stay'
        ]
    },
    {
        google_place_id: 'farmstay',
        search_terms: [
            'Farmstay',
            'Farm Stay'
        ]
    },
    {
        google_place_id: 'guest_house',
        search_terms: [
            'Guest House'
        ]
    },
    {
        google_place_id: 'hostel',
        search_terms: [
            'Hostel'
        ]
    },
    {
        google_place_id: 'hotel',
        search_terms: [
            'Hotel'
        ]
    },
    {
        google_place_id: 'lodging',
        search_terms: [
            'Lodging'
        ],
        autocomplete_id: 'lodging'
    },
    {
        google_place_id: 'motel',
        search_terms: [
            'Motel'
        ]
    },
    {
        google_place_id: 'private_guest_room',
        search_terms: [
            'Private Guest Room'
        ]
    },
    {
        google_place_id: 'resort_hotel',
        search_terms: [
            'Resort Hotel',
            'Resort'
        ]
    },
    {
        google_place_id: 'rv_park',
        search_terms: [
            'RV Park',
            'RV Campground'
        ],
        autocomplete_id: 'rv_park'
    },
    {
        google_place_id: 'church',
        search_terms: [
            'Church'
        ],
        autocomplete_id: 'church'
    },
    {
        google_place_id: 'hindu_temple',
        search_terms: [
            'Hindu Temple'
        ],
        autocomplete_id: 'hindu_temple'
    },
    {
        google_place_id: 'mosque',
        search_terms: [
            'Mosque'
        ],
        autocomplete_id: 'mosque'
    },
    {
        google_place_id: 'synagogue',
        search_terms: [
            'Synagogue'
        ],
        autocomplete_id: 'synagogue'
    },
    {
        google_place_id: 'barber_shop',
        search_terms: [
            'Barber Shop'
        ]
    },
    {
        google_place_id: 'beauty_salon',
        search_terms: [
            'Beauty Salon'
        ],
        autocomplete_id: 'beauty_salon'
    },
    {
        google_place_id: 'cemetery',
        search_terms: [
            'Cemetery'
        ],
        autocomplete_id: 'cemetery'
    },
    {
        google_place_id: 'child_care_agency',
        search_terms: [
            'Child Care Agency'
        ]
    },
    {
        google_place_id: 'consultant',
        search_terms: [
            'Consultant'
        ]
    },
    {
        google_place_id: 'courier_service',
        search_terms: [
            'Courier Service'
        ]
    },
    {
        google_place_id: 'electrician',
        search_terms: [
            'Electrician'
        ],
        autocomplete_id: 'electrician'
    },
    {
        google_place_id: 'florist',
        search_terms: [
            'Florist'
        ],
        autocomplete_id: 'florist'
    },
    {
        google_place_id: 'funeral_home',
        search_terms: [
            'Funeral Home'
        ],
        autocomplete_id: 'funeral_home'
    },
    {
        google_place_id: 'hair_care',
        search_terms: [
            'Hair Care'
        ],
        autocomplete_id: 'hair_care'
    },
    {
        google_place_id: 'hair_salon',
        search_terms: [
            'Hair Salon'
        ]
    },
    {
        google_place_id: 'insurance_agency',
        search_terms: [
            'Insurance Agency'
        ],
        autocomplete_id: 'insurance_agency'
    },
    {
        google_place_id: 'laundry',
        search_terms: [
            'Laundry',
            'Laundromat'
        ],
        autocomplete_id: 'laundry'
    },
    {
        google_place_id: 'lawyer',
        search_terms: [
            'Lawyer',
            'Attorney'
        ],
        autocomplete_id: 'lawyer'
    },
    {
        google_place_id: 'locksmith',
        search_terms: [
            'Locksmith'
        ],
        autocomplete_id: 'locksmith'
    },
    {
        google_place_id: 'moving_company',
        search_terms: [
            'Moving Company',
            'Movers'
        ],
        autocomplete_id: 'moving_company'
    },
    {
        google_place_id: 'painter',
        search_terms: [
            'Painter',
            'Painting'
        ],
        autocomplete_id: 'painter'
    },
    {
        google_place_id: 'plumber',
        search_terms: [
            'Plumber',
            'Plumbing'
        ],
        autocomplete_id: 'plumber'
    },
    {
        google_place_id: 'real_estate_agency',
        search_terms: [
            'Real Estate Agency',
            'Realtor'
        ],
        autocomplete_id: 'real_estate_agency'
    },
    {
        google_place_id: 'roofing_contractor',
        search_terms: [
            'Roofing Contractor',
            'Roofing'
        ],
        autocomplete_id: 'roofing_contractor'
    },
    {
        google_place_id: 'storage',
        search_terms: [
            'Storage',
            'Storage Facility'
        ],
        autocomplete_id: 'storage'
    },
    {
        google_place_id: 'tailor',
        search_terms: [
            'Tailor'
        ]
    },
    {
        google_place_id: 'telecommunications_service_provider',
        search_terms: [
            'Telecommunications Service Provider',
            'Telecommunications'
        ]
    },
    {
        google_place_id: 'travel_agency',
        search_terms: [
            'Travel Agency',
            'Travel Agent'
        ],
        autocomplete_id: 'travel_agency'
    },
    {
        google_place_id: 'veterinary_care',
        search_terms: [
            'Veterinary Care',
            'Veterinarian'
        ],
        autocomplete_id: 'veterinary_care'
    },
    {
        google_place_id: 'auto_parts_store',
        search_terms: [
            'Auto Parts Store',
            'Auto Parts'
        ]
    },
    {
        google_place_id: 'bicycle_store',
        search_terms: [
            'Bicycle Store',
            'Bicycle Shop',
            'Cycling Shop'
        ],
        autocomplete_id: 'bicycle_store'
    },
    {
        google_place_id: 'book_store',
        search_terms: [
            'Book Store',
            'Book Shop'
        ],
        autocomplete_id: 'book_store'
    },
    {
        google_place_id: 'cell_phone_store',
        search_terms: [
            'Cell Phone Store',
            'Cell Phone Shop'
        ]
    },
    {
        google_place_id: 'clothing_store',
        search_terms: [
            'Clothing Store',
            'Clothing Shop'
        ],
        autocomplete_id: 'clothing_store'
    },
    {
        google_place_id: 'convenience_store',
        search_terms: [
            'Convenience Store',
            'Convenience Shop'
        ],
        autocomplete_id: 'convenience_store'
    },
    {
        google_place_id: 'department_store',
        search_terms: [
            'Department Store',
            'Department Shop'
        ],
        autocomplete_id: 'department_store'
    },
    {
        google_place_id: 'discount_store',
        search_terms: [
            'Discount Store',
            'Discount Shop'
        ]
    },
    {
        google_place_id: 'electronics_store',
        search_terms: [
            'Electronics Store',
            'Electronics Shop'
        ],
        autocomplete_id: 'electronics_store'
    },
    {
        google_place_id: 'furniture_store',
        search_terms: [
            'Furniture Store',
            'Furniture Shop'
        ],
        autocomplete_id: 'furniture_store'
    },
    {
        google_place_id: 'hardware_store',
        search_terms: [
            'Hardware Store',
            'Hardware Shop'
        ],
        autocomplete_id: 'hardware_store'
    },
    {
        google_place_id: 'home_goods_store',
        search_terms: [
            'Home Goods Store',
            'Home Goods Shop'
        ],
        autocomplete_id: 'home_goods_store'
    },
    {
        google_place_id: 'home_improvement_store',
        search_terms: [
            'Home Improvement Store',
            'Home Improvement Shop'
        ]
    },
    {
        google_place_id: 'jewelry_store',
        search_terms: [
            'Jewelry Store',
            'Jewelry Shop'
        ],
        autocomplete_id: 'jewelry_store'
    },
    {
        google_place_id: 'liquor_store',
        search_terms: [
            'Liquor Store',
            'Liquor Shop'
        ],
        autocomplete_id: 'liquor_store'
    },
    {
        google_place_id: 'market',
        search_terms: [
            'Market'
        ]
    },
    {
        google_place_id: 'pet_store',
        search_terms: [
            'Pet Store',
            'Pet Shop'
        ],
        autocomplete_id: 'pet_store'
    },
    {
        google_place_id: 'shoe_store',
        search_terms: [
            'Shoe Store',
            'Shoe Shop'
        ],
        autocomplete_id: 'shoe_store'
    },
    {
        google_place_id: 'shopping_mall',
        search_terms: [
            'Shopping Mall',
            'Mall'
        ],
        autocomplete_id: 'shopping_mall'
    },
    {
        google_place_id: 'sporting_goods_store',
        search_terms: [
            'Sporting Goods Store',
            'Sporting Goods Shop',
            'Athletic Store',
            'Athletic Shop'
        ]
    },
    {
        google_place_id: 'store',
        search_terms: [
            'Store',
            'Shop'
        ],
        autocomplete_id: 'store'
    },
    {
        google_place_id: 'supermarket',
        search_terms: [
            'Supermarket'
        ],
        autocomplete_id: 'supermarket'
    },
    {
        google_place_id: 'wholesaler',
        search_terms: [
            'Wholesaler'
        ]
    },
    {
        google_place_id: 'athletic_field',
        search_terms: [
            'Athletic Field',
            'Field'
        ]
    },
    {
        google_place_id: 'fitness_center',
        search_terms: [
            'Fitness Center',
            'Gym',
            'Fitness Club'
        ]
    },
    {
        google_place_id: 'golf_course',
        search_terms: [
            'Golf Course'
        ]
    },
    {
        google_place_id: 'gym',
        search_terms: [
            'Gym',
            'Fitness Center',
            'Fitness Club'
        ],
        autocomplete_id: 'gym'
    },
    {
        google_place_id: 'ski_resort',
        search_terms: [
            'Ski Resort'
        ]
    },
    {
        google_place_id: 'sports_club',
        search_terms: [
            'Sports Club',
            'Athletic Club',
            'Athletic Center'
        ]
    },
    {
        google_place_id: 'sports_complex',
        search_terms: [
            'Sports Complex',
            'Athletic Complex'
        ]
    },
    {
        google_place_id: 'stadium',
        search_terms: [
            'Stadium',
            'Arena'
        ],
        autocomplete_id: 'stadium'
    },
    {
        google_place_id: 'swimming_pool',
        search_terms: [
            'Swimming Pool',
            'Pool'
        ]
    },
    {
        google_place_id: 'airport',
        search_terms: [
            'Airport',
            'Airfield'
        ],
        autocomplete_id: 'airport'
    },
    {
        google_place_id: 'bus_station',
        search_terms: [
            'Bus Station',
            'Bus Stop'
        ],
        autocomplete_id: 'bus_station'
    },
    {
        google_place_id: 'bus_stop',
        search_terms: [
            'Bus Stop',
            'Bus Station'
        ]
    },
    {
        google_place_id: 'ferry_terminal',
        search_terms: [
            'Ferry Terminal'
        ]
    },
    {
        google_place_id: 'heliport',
        search_terms: [
            'Heliport'
        ]
    },
    {
        google_place_id: 'light_rail_station',
        search_terms: [
            'Light Rail Station'
        ],
        autocomplete_id: 'light_rail_station'
    },
    {
        google_place_id: 'park_and_ride',
        search_terms: [
            'Park and Ride'
        ]
    },
    {
        google_place_id: 'subway_station',
        search_terms: [
            'Subway Station',
            'Subway Stop',
            'Metro Station',
            'Metro Stop',
            'Lightrail Station',
            'Lightrail Stop'
        ],
        autocomplete_id: 'subway_station'
    },
    {
        google_place_id: 'taxi_stand',
        search_terms: [
            'Taxi Stand',
            'Taxi Stop'
        ],
        autocomplete_id: 'taxi_stand'
    },
    {
        google_place_id: 'train_station',
        search_terms: [
            'Train Station',
            'Train Stop',
            'Railway Station',
            'Railway Stop'
        ],
        autocomplete_id: 'train_station'
    },
    {
        google_place_id: 'transit_depot',
        search_terms: [
            'Transit Depot',
            'Transit Station',
            'Transit Stop'
        ]
    },
    {
        google_place_id: 'transit_station',
        search_terms: [
            'Transit Station',
            'Transit Stop'
        ],
        autocomplete_id: 'transit_station'
    },
    {
        google_place_id: 'truck_stop',
        search_terms: [
            'Truck Stop',
            'Truck Station'
        ]
    }
];


export const inspirationMapIds = [
    '649ca82212dd1d7537b68093',
    '6480bded4b6722b5c7c018f4',
    '63feee1f2ba0652769432ff8',
    '6463afeeb5ae02217120e289',
    '643486e6bd90ed896c080922',
    '649b62cf2fcd60d758300cca',
    '647f71ea17810c6bca4e5f3b',
    '63ed67a759b14092a1cf4441',
    '62596ad780aeba1aab5ac607',
    '631f8641ef06fb0bd3ae5935',
    '64d66bdb27968a0ee0465e2c',
    '6267ee2e99fd14f835113cf6',
    '63ed330759b14092a1cf4070',
    '648b487fa9c48f5a6804afaa',
    '649a27b21e5a95796f769d23',
    '642b7ee946753dac6e851138',
    '63878dcac23ee58bf8a06ff9',
    '649b014612dd1d7537b64130',
    '65433fb38c60257d9f554ce8',
    '6532a5da166b2192c2e64537',
    '6541545aa7d6f33caa1bcd8d',
    '6543bb1aa7d6f33caa1c8ce1'
];

export const supportedLanguages = [
    {code: 'en', name: 'English', nativeName: 'English'},
    {code: 'zh', name: 'Chinese(Simplified)', nativeName: '中文(简体)'},
    {code: 'tw', name: 'Chinese(Traditional)', nativeName: '中文(繁體)'},
    {code: 'ar', name: 'Arabic', nativeName: 'العربية'},
    {code: 'tr', name: 'Turkish', nativeName: 'Türkçe'},
    {code: 'es', name: 'Spanish', nativeName: 'Español'},
    {code: 'fr', name: 'French', nativeName: 'Français'},
];

export const standardFields: VisibilityField[] = [
    {name: 'Category', value: 'category', inputType: 'select', formPart: LogicFieldType.StandardField},
    {name: 'Title', value: 'title', inputType: 'text', formPart: LogicFieldType.StandardField},
    {name: 'Description', value: 'description', inputType: 'text', formPart: LogicFieldType.StandardField},
    {name: 'Tags', value: 'tags', inputType: 'select', formPart: LogicFieldType.StandardField},
    {name: 'Special Offer', value: 'special_offer', inputType: 'text', formPart: LogicFieldType.StandardField},
    {name: 'More Info', value: 'more_info', inputType: 'text', formPart: LogicFieldType.StandardField},
    {name: 'Photos', value: 'photos', inputType: 'select', options: [{name: 'Has Photos', value: 'true'}, {name: 'No Photos', value: 'false'}], formPart: LogicFieldType.StandardField},
    {name: 'Email', value: 'email', inputType: 'text', formPart: LogicFieldType.StandardField},
    {name: 'Terms', value: 'terms', inputType: 'select', options: [{name: 'Agreed To', value: 'true'}, {name: 'Unselected', value: 'false'}], formPart: LogicFieldType.StandardField},
];


// Dummy data for CreateElectionRequest
export const dummyInitialElection: CreateElectionRequest = {
    name: 'My Election',
    active: false,
    description: 'You can vote for your favorite categories in my election',
    category_descriptions: [],
    email_terms: 'By voting you acknowledge that we might send you follow up emails about the election and our organization',
    email_opt_in_required: false,
    verify_email: true,
    start_time: new Date(Date.now() - 24 * 60 * 60 * 1000).toISOString(), // subtract 24 hours
    end_time: new Date(Date.now() + 24 * 60 * 60 * 1000).toISOString(), // add 24 hours
    point_button_text: 'Vote Now',
    submit_button_text: 'Submit Vote',
    show_leaders: undefined,
    nomination_is_live: false,
    multi_select: false,
    frequency_quantity: 1,
    frequency_recurrance: 'daily',
    check_ip_address: true,
    excluded_categories: [],
    excluded_points: [],
};

// Dummy data for CreateElectionResponse
export const createTopicElectionResponse: CreateElectionResponse = {
    _id: {$oid: '123'},
};



const ballotSection: BallotSection = {
    category_id: {$oid: '123'},
    selected: [
        {
            point_id: {$oid: '123'},
            point_name: 'Point 1',
        },
    ],
};

// Dummy data for CreateBallotRequest
export const createBallotRequest: CreateBallotRequest = {
    topic_id: {$oid: '123'},
    election_id: {$oid: '123'},
    email: 'user@example.com',
    ip_address: '192.168.1.1',
    email_opt_in: true,
    email_opt_in_language: 'en',
    timestamp: new Date().toISOString(),
    ballot: [ballotSection]
};

// Dummy data for CreateBallotResponse
export const createBallotResponse: CreateBallotResponse = {
    _id: {$oid: '123'},
    timestamp: new Date().toISOString(),
};

// Dummy data for GetBallotResponse
export const getBallotResponse: GetBallotResponse = {
    _id: {$oid: '123'},
    timestamp: new Date().toISOString(),
    topic_id: {$oid: '123'},
    email: 'user@example.com',
    ip_address: '192.168.1.1',
    email_opt_in: true,
    email_opt_in_language: 'en',
    ballot: [ballotSection],
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
};

// temporary JLL html for form for testing here
export function getJLLFormHMTL(developmentID: string) { return `
<!--Wechat form created by-
 * Name: LUUX Mena enquiry form
 * Description: test form for LUUX Mena
 * Created Date: [23/09/2024]
 * Created By:IH (Resiforce)
 * Environment: UAT
-->
<html>
<head>
  <meta charset="utf-8">
  <script src="https://ajax.googleapis.com/ajax/libs/jquery/3.1.1/jquery.min.js"></script>
  <link href="https://fonts.googleapis.com/css?family=Open+Sans:400,700" rel="stylesheet">

  <style type="text/css">
    * {
      box-sizing: border-box;
    }

    body {
      padding: 20px;
      font-family: 'Open Sans', sans-serif;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      background: #ededed;
    }

    input {
      padding: 10px;
      font-size: 15px;
      border: 1px solid #999;
      border-radius: 3px;
      outline: none;
      width: 100%;
    }

    td {
      padding-bottom: 8px;
      vertical-align: top;
    }

    button {
      font-size: 13px;
      font-weight: bold;
      padding: 10px;
      border: none;
      border-radius: 3px;
      background: black;
      color: white;
      outline: none;
      cursor: pointer;
    }

    textarea {
      width: 100%;
      height: 100px;
      padding: 10px;
      font-size: 15px;
      border: 1px solid #999;
      border-radius: 3px;
      outline: none;
    }

    h1 {
      margin-bottom: 10px;
    }

    .required {
      background: ${palette.primaryBlue};
      color: white;
      display: inline-block;
      font-size: 11px;
      padding: 3px 8px;
      border-radius: 3px;
      margin-top: 3px;
      font-weight: bold;
    }

    .error {
      color: red;
      font-weight: bold;
      padding-top: 4px;
      font-size: 13px;
    }

    .td-label {
      text-align: right;
      padding-right: 20px;
    }

    .td-submit {
      text-align: right;
    }

    .intro {
      color: #7b7b7b;
    }
  </style>
  <script async src='/cdn-cgi/bm/cv/669835187/api.js'></script>
</head>

<body>
  <div class="wrapper">
    <form action="https://front-desk.propertybase.com/forms/47ed68aebf10236f0101161091788efc3029c0c3" method="post"
      data-validate>
      <table border="0" width="100%">
        <tr>
          <td width="100" class="td-label">
            <div><strong>First name</strong></div>
          </td>
          <td>
            <input type="text" name="contact[FirstName]">
          </td>
        </tr>
        <tr>
          <td width="100" class="td-label">
            <div><strong>Last name</strong></div>
            <div class="required">Required</div>
          </td>
          <td>
            <input type="text" name="contact[LastName]" data-required required>
          </td>
        </tr>
        <tr>
          <td width="100" class="td-label">
            <div><strong>Email</strong></div>
            <div class="required">Required</div>
          </td>
          <td>
            <input type="text" name="contact[Email]" data-required data-email required>

          </td>
        </tr>
        <tr>
          <td width="100" class="td-label">
            <div><strong>Phone Number</strong></div>
          </td>
          <td>
            <input type="text" name="contact[MobilePhone]">
          </td>
        </tr>

                <!-- ****************************************** -->


                <tr>
                  <td width="100" class="td-label">
                    <div><strong>Price Max</strong></div>
                    <div class="required">Required</div>
                  </td>
                  <td>
                    <select name="request[pba__ListingPrice_pb_max__c]" data-required required>
                      <option value="">Select a Price</option>
                      <option value="250000">£250,000</option>
                      <option value="500000">£500,000</option>
                      <option value="750000">£750,000</option>
                      <option value="1000000">£1,250,000</option>
                      <option value="1500000">£1,500,000</option>
                      <option value="1750000">£1,750,000</option>
                      <option value="2000000">£2,000,000</option>
                      <option value="5000000">£5,000,000</option>
                      <option value="10000000">£10,000,000</option>
                    </select>
                  </td>
                </tr>
                                <!-- ****************************************** -->

                <tr>
                  <td width="100" class="td-label">
                    <div><strong>Bedrooms Min</strong></div>
                    <div class="required">Required</div>
                  </td>
                  <td>
                    <select name="request[pba__Bedrooms_pb_min__c]" data-required required>
                      <option value="">Select Rooms</option>
                      <option value="1">1</option>
                      <option value="2">2</option>
                      <option value="3">3</option>
                      <option value="4">4</option>
                      <option value="5">5</option>
                    </select>
                  </td>
                </tr>

                 <!-- ****************************************** -->
                 <tr>
                  <td width="100" class="td-label">
                    <input type="checkbox" id="gdpr" name="request[rf_GDPR_Opt_in_Digital__c]" checked value="true" />
                  </td>
                  <td>
                    <div><strong>Please opt-in to receive communications from JLL Residential</strong></div>
                  </td>
                </tr>


                  <!-- ****************************************** -->
       <tr>
          <td>
            <input type="hidden" name="success_url" value="https://map.proxi.co/r/e8rM5LQSMPTXZwMN28Zh"><!--Please modify this to redirect the page once the form is sent to Resiforce-->
            <!--Resiforce Team fields-->
            <input type="hidden" name="unique_id_field" value="pba__Broker_s_Listing_ID__c" /><!-- do not modify-->
            <input type="hidden" name="contact[ContactType__c]" value="Applicant" /><!-- do not modify-->
            <input type="hidden" name="request[Technical_Source_System__c]" value="FrontDesk" /><!-- do not modify-->
            <input type="hidden" name="request[pb_Source__c]" value="DigitalPortfolio" /><!-- do not modify-->
            <!--variables-->
            <input type="hidden" name="request[rf_Broker_s_Listing_ID__c]" value="${developmentID}" /><!-- - DevelopmentId variable from Liam Bayford to add to the brokerid field-->
            <!--input type="hidden" name="request[rf_GDPR_Opt_in_Digital__c]" value="false" /><!--Value Variable for GDPR-->

            <!--Resiforce Team fields-->
            <input type="hidden" name="request[rf_Enquiry_Inbox__c]" value="i7iyu8s1lx@in.propertybase.com" /><!--do not modify - This email is exclusive to MENA by RF team-->
            <input type="hidden" name="request[pbasr__Front_Desk_Email__c]" value="i7iyu8s1lx@in.propertybase.com" /><!--do not modify - This would be updated for the live app version by RF team-->
            <!--Resiforce Team fields-->

            <!-- do not modify-->
            <input type="hidden" name="h_47ed68aebf10236f0101161091788efc3029c0c3" value="" style="display.none" />
          </td>
        </tr>
        <tr>
          <td colspan="2" class="td-submit">
            <button type="submit">
              Submit
            </button>
          </td>
        </tr>
      </table>
    </form>
  </div>
    <script>
        document.addEventListener('DOMContentLoaded', function () {
            const form = document.querySelector('form');
            form?.addEventListener('submit', function (event) {
                let isValid = true;

                // Check required fields
                const requiredFields = document.querySelectorAll('.required-field') as NodeListOf<HTMLInputElement>;
                requiredFields.forEach(function (field: HTMLInputElement) {
                    if (!field.value) {
                        isValid = false;
                        field.classList.add('error');
                    } else {
                        field.classList.remove('error');
                    }
                });

                // Prevent form submission if validation fails
                if (!isValid) {
                    event.preventDefault();
                    alert('Please fill in all required fields.');
                }
            });
        });
    </script>
  <script
    type="text/javascript">(function () { window['__CF$cv$params'] = { r: '65f4f571eb08406c', m: '50670d768245fe125c3fafee239a71eb0e6701af-1623688390-1800-AR9oKBkXPq7FOdEsR2t2XlKTtokR/c56eFwq59aTAXGzt0xkjVx0T7/GPRTY4qtcrVVdcfyGbslxqaCVF2zQpaKX+baJJ2UqkitUbfm2PrGistLAbOtnPgkgIHFNoD2vrXGVGKJhrPcOWv2ZlG0Gh0lqw9zJXB0QktI9CBoO5xrcGakf7o5oH0lHEE0ESqh+pPe4V2l9SIyNG1UsgbWn8Ck=', s: [0xd13d001eb6, 0x909726f85c], } })();</script>
</body>

</html>
`;
}

export const temp_addon: GetAddOnResponse = {
  '_id': {
    '$oid': '691c9eccab05efbf42be21e5'
  },
  'title': 'Guide',
  'subtitle': 'Turn your map into an interactive, personalized guide for your audience.',
  'description': 'Activate Guides, a Proxi product designed to help you deliver a personalized, app-like city guide without any downloads. Create a guide your audience can register for, then automatically give each person a unique link where they can save places, build their own list, and access it from their home screen just like an app. You can customize the icon and name, and stay connected through SMS and email updates that keep your guide fresh and engaging.',
  'icon_path': 'auto_stories',
  'availability': AddOnAvailability.Available,
  'component': AddOnType.Guide,
  'owner': 'Proxi',
  'required_entitlements': [
    FeatureType.Guide
  ],
  'gated': false,
  'video_demo_link': '',
  'documentation_link': undefined,
  'support_message': undefined,
  'example_map_ids': undefined,
  'is_featured': false,
  'is_public': true,
  'marketing_page_link': undefined,
  'associated_blogs': [
  ]
};

export const high_street_treasure_hunt_add_on: GetAddOnResponse = {
  '_id': {
    '$oid': '695d3afec43327031c427d7d'
  },
  'title': 'Treasure Hunt',
  'subtitle': 'Turn your map into a gamified experience as a scavenger hunt. Viewers can earn points and rewards by visiting locations on your map.',
  'description': 'The scavenger hunt feature enables map creators to associate scavenger hunts with their maps, allowing users to actively participate, check in at specific locations, earn points, and potentially receive rewards. It provides map creators with the ability to design captivating scavenger hunts and empowers users with a gamified exploration experience, enhancing their motivation and overall engagement.',
  'icon_path': 'diamond',
  'availability': AddOnAvailability.Available,
  'component': AddOnType.TreasureHunt,
  'owner': 'Proxi',
  'required_entitlements': [
    FeatureType.ScavengerHunt
  ],
  'gated': false,
  'is_featured': false,
  'is_public': true,
};

export const highStreetCluesAndCodes: Array<{number: string, clueImage: string, code: string}> = [
    { number: '10', clueImage: 'https://map.proxi.co/i/CpFh4ClbXLsL9vvV442I1SXL2xikow.png', code: '2501' },
    { number: '2', clueImage: 'https://map.proxi.co/i/jJEAwpkoyYjwl2lfAOQIwL6zhSPGOI.png', code: '1400' },
    { number: '3', clueImage: 'https://map.proxi.co/i/r-gvH5ltzLDNMYBOdQHxJJzt_x0gTf.png', code: '9297' },
    { number: '9', clueImage: 'https://map.proxi.co/i/KbCh-UMQ91XHeLStonp8NJmFkqFOfr.png', code: '5632' },
    { number: '4', clueImage: 'https://map.proxi.co/i/0Lmz8qpEUKRdFVBNi7fgKws-eQw_4T.png', code: '7483' },
    { number: '1', clueImage: 'https://map.proxi.co/i/58BHht-tgouiuE_R8tyyO-W__rkDBh.png', code: '3156' },
    { number: '6', clueImage: 'https://map.proxi.co/i/Kitv5T4W-_5Mz52B2N_zWuLgjhe0Ua.png', code: '4820' },
    { number: '5', clueImage: 'https://map.proxi.co/i/45V0ZgSIAX7doWVBB0MhnRfjHhfwuN.png', code: '6074' },
    { number: '8', clueImage: 'https://map.proxi.co/i/hS1SjTNhQbKOlzyC_mIuxWWpA_z0td.png', code: '1985' },
    { number: '7', clueImage: 'https://map.proxi.co/i/b_R2DrXBeg5eJ_hBI6OVeOFSIAWavu.png', code: '3349' },
];